module.exports = __webpack_public_path__ + "de77a722/img/archive-icon.0a6a9de3.svg";